import { Button, Form, Modal, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { SelectItemDto } from "../../../../types/SelectItemDto";

type ImprovementPlanDeleteModalProps = {
    show: boolean;
    title: string;
    subtitle: string;
    isLoadingOptions: boolean;
    isDeleting: boolean;
    options: SelectItemDto[];
    selectedReasonId: number | null;
    error?: string;
    onClose: () => void;
    onConfirm: () => void;
    onReasonChange: (reasonId: number | null) => void;
};

export default function ImprovementPlanDeleteModal({
    show,
    title,
    subtitle,
    isLoadingOptions,
    isDeleting,
    options,
    selectedReasonId,
    error,
    onClose,
    onConfirm,
    onReasonChange
}: ImprovementPlanDeleteModalProps) {
    const { t } = useTranslation(["common", "improvementPlan"]);

    return (
        <Modal show={show} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {isLoadingOptions ? (
                    <div className="text-center py-3">
                        <Spinner animation="border" />
                    </div>
                ) : (
                    <>
                        <p>{subtitle}</p>
                        <Form.Group>
                            <Form.Label>{t("common:modalDeleteReasonInput")}</Form.Label>
                            <Form.Select
                                value={selectedReasonId ?? ""}
                                isInvalid={!!error}
                                onChange={(event) => onReasonChange(event.target.value ? Number(event.target.value) : null)}
                            >
                                <option value="">{t("common:selectDefaultText")}</option>
                                {options.map((option) => (
                                    <option key={option.id} value={option.id}>
                                        {option.name}
                                    </option>
                                ))}
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
                        </Form.Group>
                    </>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose} disabled={isDeleting || isLoadingOptions}>
                    {t("common:modalActionNOTOK")}
                </Button>
                <Button variant="primary" onClick={onConfirm} disabled={isDeleting || isLoadingOptions}>
                    {isDeleting && (
                        <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                            className="me-2"
                        />
                    )}
                    {t("common:modalActionOK")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
